import 'es6-shim'

import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './views/App'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'
import VueLazyLoad from 'vue-lazyload'
// import VueTouch from 'vue-touch'
// import Log from './plugins/log'

Vue.use(VueLazyLoad)
// Vue.use(VueTouch, { name: 'v-touch' })
// Vue.use(Log)

import VeeValidate from 'vee-validate'
const veeValidateConfig = {
  errorBagName: 'veeValidateErrors', // change if property conflicts.
  fieldsBagName: 'veeValidateFields',
  delay: 100,
  locale: 'de',
  dictionary: null,
  strict: true,
  classes: true,
  classNames: {
    touched: 'is-touched', // the control has been blurred
    untouched: 'is-untouched', // the control hasn't been blurred
    valid: 'is-valid', // model is valid
    invalid: 'is-invalid', // model is invalid
    pristine: 'is-pristine', // control has not been interacted with
    dirty: 'is-dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true,
  validity: true,
  aria: true
}
Vue.use(VeeValidate, veeValidateConfig)

sync(store, router)

Vue.use(VueGtag, {
  config: {
    id: 'G-07MSX6KN0W',
    params: {
      anonymize_ip: true
    }
  },
  bootstrap: false
}, router)

const app = new Vue({
  router,
  store,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js